import { savedOrderDetailsTotalStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsTotal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

savedOrderDetailsTotalStyles.cartTotal = {
    container: {
        gap: 10,
        css: css`
            background-color: ${getColor("common.ui2")};
            padding: 20px;
        `,
    },
};
